import axios from "axios"

const controller = "/cliente"

const ClienteService = {
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    obtenerDirecciones: async (request) => {
        const { data } = await axios.post(`${controller}/obtenerDirecciones`, request)
        return data
    },
}

export default ClienteService